import Notification from './Notification';
import { useNotificationStore } from './notificationStore';
const NotificationsContainer = () => {
	const notifications = useNotificationStore((state) => state.notifications);
	if (notifications.length === 0) return null;
	return (
		<div className="z-50 w-96 toast toast-top toast-end">
			{notifications.map((notification) => (
				<Notification key={notification.id} {...notification} />
			))}
		</div>
	);
};

export default NotificationsContainer;
